import { Avatar, Badge, Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectSchool } from "../../../redux/school/schoolSlice";
import { selectDpto } from "../../../redux/dpto/dptoSlice";
import { styled } from "@mui/material/styles";
import { stringAvatar, stringToColor } from "../../../features/user/avatarUtils";
import { assertThumbnailUrl } from "../../../redux/common";

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 20,
  height: 20,
  border: `2px solid ${theme.palette.background.paper}`,
  fontSize: "0.5rem",
}));

interface DptoPageAvatarProps {
}

const DptoPageAvatar = ({}: DptoPageAvatarProps) => {
  const school = useSelector( selectSchool );
  const dpto = useSelector( selectDpto );

  return (school.selected && dpto.selected) ?
    <Box sx={{ mr: 2 }}>
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        badgeContent={
          <SmallAvatar alt={`${school.selected.name}`} src={`${assertThumbnailUrl(school.selected.url)}`} />
        }>
          <Avatar sx={{ backgroundColor: stringToColor(dpto.selected.name) }} alt={`${dpto.selected.name}`} src={`${assertThumbnailUrl(dpto.selected.url)}`}>
            <Typography variant="h6" component="span">
              {stringAvatar(dpto.selected.name)}
            </Typography>
          </Avatar>
      </Badge>
    </Box>
    : <></>;
};

export default DptoPageAvatar;